import {gtmTags} from "@/constants/data-layers";
import {appleOandaFaviconLinks, oandaFaviconLinks} from "@/constants/favicon-icon";

export class OandaHelper {

  public static updateFavicon(): void {
    //update favicon for oanda page
    const faviconIcons: NodeListOf<Element> = document.querySelectorAll("link[rel~='icon']");
    for(const icon of faviconIcons) {
      if(icon.hasAttribute('sizes')) {
        const size = icon.getAttribute('sizes');
        // @ts-ignore
        if(oandaFaviconLinks[size]) {
          // @ts-ignore
          icon.setAttribute('href', oandaFaviconLinks[size])
        }
      } else {
        icon.setAttribute('href', oandaFaviconLinks.default);
      }
    }

    //update apple favicon for oanda page
    const appleIcons: NodeListOf<Element> = document.querySelectorAll("link[rel~='apple-touch-icon']");
    for(const icon of appleIcons) {
      if(icon.hasAttribute('sizes')) {
        const size = icon.getAttribute('sizes');
        // @ts-ignore
        if(appleOandaFaviconLinks[size]) {
          // @ts-ignore
          icon.setAttribute('href', appleOandaFaviconLinks[size])
        }
      } else {
        icon.setAttribute('href', appleOandaFaviconLinks.default);
      }
    }
  }
}